import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Spinner } from 'reactstrap';
import { verifyProperty } from 'store/slices/businessSlice';
export class VerifyDomain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null
    };
    this.verify = this.verify.bind(this);
  }

  verify() {
    this.setState({
      loading: true,
      error: null
    });
    this.props.verifyProperty(this.props.property.objectId).then(res => {
      if (!res.success) {
        this.setState({
          error: res.error || 'Verification failed',
          loading: false
        });
      } // If success don't update the state because the component will be unmounted

    }).catch(err => this.setState({
      error: err.message || 'Verification failed',
      loading: false
    }));
  }

  render() {
    const { t } = this.props;
    const {
      loading,
      error
    } = this.state;
    const {
      property
    } = this.props;
    return <>
        <Row>
          <Col>
            {/* eslint-disable-next-line no-mixed-operators */}
            <p>{t("To verify domain")}{property.parameters && (property.parameters[1] && property.parameters[1].value || property.parameters['1'] && property.parameters['1'].value) || ''}{t("update your DNS records.")}</p>
            <p>{t("Add")}<code>{t("TXT")}</code>{t("record with name")}<code>{property.meta && property.meta.verification && property.meta.verification.name}</code>{t("and value")}<code>{property.meta && property.meta.verification && property.meta.verification.value}</code></p>
            <Button color='primary' disabled={loading} className='mb-3' onClick={this.verify}>{t("Verify")}{loading && <Spinner size='sm' />}
            </Button>
            {error && <>
                <p className='text-danger'>{error}</p>
                <p>{t("DNS could take up to 24-72 hours to update. Please check back later.")}</p>
              </>}
          </Col>
        </Row>

      </>;
  }

}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  verifyProperty: propertyId => dispatch(verifyProperty(propertyId))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VerifyDomain));